<template>
    <div :class="['page', language === 'cn' ? 'font-cn' : 'font-en']">
      <!-- Content Section and Navigation Together -->
      <div class="content-wrapper">
        <!-- Content Section -->
        <div class="content-section">
          <div v-for="(item, index) in content.Items" :key="index" class="content-item">
            <div class="card">  
              <div class="card-body">
                <h1 class="title">{{ item.title }}</h1>
                <div v-html="formattedDescription(item.description_1)" class="description"></div>
                <div class="card-header">
                  <img :src="item.image_1" alt="Content Image" class="image" />
                </div>  
                <div v-html="formattedDescription(item.description_2)" class="description"></div>
                <div class="card-header">
                  <img :src="item.image_2" alt="Content Image" class="image" />
                </div>
                <div v-html="formattedDescription(item.description_3)" class="description"></div>
                <div class="card-header">
                  <img :src="item.image_3" alt="Content Image" class="image" />
                </div>
                <div v-html="formattedDescription(item.description_4)" class="description"></div>  
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </template>
  
  <style src="@/assets/css/news.css" scoped></style>
  
  <script>
  import { mapState } from "vuex";
  export default {
    data() {
      return {
        cn: {
          Items: [
            {
              id: 1,
              image_1: require("@/assets/img/News/010/FairyFrontdoor.jpeg"),
              image_2: require("@/assets/img/News/010/FairyCombined.png"),
              image_3: require("@/assets/img/News/010/FairyGroupPhoto.jpg"),
              title: "宁波市区首家VR Park主题公园“童话之城”开业",
              description_1:`
                2024年10月1日，在云翰虹章、VR Vidámpark团队与宁波科学探索中心三方的共同努力下，宁波地区首家VR Park主题公园“童话之城”于宁波科学探索中心开业。
              `,
              description_2:`
                宁波科学探索中心是集科普教育、休闲娱乐为一体的大型互动式体验科普场馆，也是国家级科普教育基地。作为宁波本地科普领域的领航者，宁波科学探索中心始终将传播科学精神、普及科学知识作为己任，致力于推动科技与文化的融合发展。

                国庆期间，该店收获了广泛的关注和良好的口碑，票房突破1500人次，多场次一经开放即告售罄，成功打造出“人气神话”。不少亲子家庭前来“二刷三刷”，《童话之城》主题店一跃成为了宁波亲子和年轻人打卡的热门新地标。
              `,
              description_3:`
                云翰虹章团队为该店提供了全方位的技术支持，包括软硬件安装，长期运维，员工培训等。通过我们的协助，该店成功开业并能长期稳定运营。我们期待着在未来，与宁波科学探索中心继续携手，共同推动VR LBE技术在文化旅游产业上的发展，为更多游客带来独特的沉浸式体验。
              `,
              description_4:`
                如上图为开业当天，云翰虹章团队商务代表人（右下一）与合作伙伴代表以及各领导嘉宾的合影。
              `,
            },
            // Add more items as needed
          ],
        },
        en: {
          Items: [
            {
              id: 2,
              image_1: require("@/assets/img/News/010/FairyFrontdoor.jpeg"),
              image_2: require("@/assets/img/News/010/FairyCombined.png"),
              image_3: require("@/assets/img/News/010/FairyGroupPhoto.jpg"),
              title: "The First VR Park in Ningbo Central City, 'Fairy Tale City', Opens!",
              description_1:`
                On 1st October 2024, with the joint efforts of Rosy Nebula, VR Vidámpark team and Ningbo Science Exploration Centre, the first VR Park in Ningbo, ‘Fairytale City’, was opened at the Ningbo Science Exploration Centre.
              `,
              description_2:`
                Ningbo Science Exploration Centre is a large-scale interactive experience science museum integrating science education, leisure and entertainment, and is also a national science education base. As a leader in the field of local science popularisation in Ningbo, Ningbo Science Exploration Centre has always taken spreading the spirit of science and popularising scientific knowledge as its own responsibility, and is committed to promoting the integration and development of science and technology and culture.

                During the National Day, the shop gained wide attention and good reputation, the box office exceeded 1,500 people, and many shows were sold out as soon as they opened, successfully creating a ‘popularity myth’. Many parent-child families came to ‘two brushes and three brushes’, and the theme shop of ‘Fairytale City’ became a popular new landmark for parents and children and young people in Ningbo.
              `,
              description_3:`
                Rosy Nebula team provided full technical support for the shop, including hardware and software installation, long-term operation and maintenance, and staff training. Through our assistance, the shop was successfully opened and was able to operate stably for a long time. We look forward to continuing to work together with Ningbo Science Exploration Centre in the future to promote the development of VR LBE technology in the cultural tourism industry, and to bring a unique immersive experience to more visitors.
              `,
              description_4:`
                As shown in the picture above, Rosy Nebula's team of business representatives (the lower right one) took a group photo with partner representatives and various leading guests on the opening day.
              `,
            },
            // Add more items as needed
          ],
        },
      };
    },
    methods: {
      formattedDescription(description) {
        // Apply additional formatting if needed
        return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
      },
      formattedDescriptionNo(description_no) {
        // Apply additional formatting if needed
        return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
      },
    },
    mixins: [],
    computed: {
      ...mapState(["language"]),
      content() {
        const defaultContent = { title: "", industry_areas: [] };
        const currentLanguage = this.language === "en" ? this.en : this.cn;
        console.log("Current Language:", currentLanguage); // Debug statement
        return currentLanguage || defaultContent;
      },
    },
    watch: {
      language(newValue) {
        console.log("Language changed to:", newValue); // Debug statement
        this.$forceUpdate(); // Force the component to re-render when the language changes
      },
    },
  };
  </script>
